<ng-container [caLocalizationScope]="localizationScope">
  <div class="d-flex flex-column">
    <div class="d-flex align-items-center mt-2 mb-4 body-70">
      <i data-automation-id="company-title" class="f-i f-i-bank f-i-sm text-muted"></i> {{ targetCompanyData.name }}
    </div>
    <div class="border-bottom mb-4"></div>
    <div class="d-flex justify-content-between mb-3 form-label-top">
      <span class="heading-20" data-automation-id="priority-rating-title">{{ 'institutionRating' | caLocalize }}</span>
      @if(targetCompanyData.customTargetRating){
      <span class="link link-primary" (click)="onReset()" data-automation-id="reset-customizations">{{
        'resetCustomizations' | caLocalize
      }}</span>
      }
    </div>

    <div class="chip-list d-flex flex-wrap mb-1">
      <f-chip
        *ngFor="let item of institutionRatingItems"
        class="me-1"
        [size]="chipSize"
        [type]="getChipType(item)"
        [ngClass]="{ 'chip-disabled': item.disabled }"
        (chipClick)="onSelect(item)"
        [attr.title]="item.disabled ? item.iconPopoverContent : null"
        data-automation-id="priority-rating"
      >
        {{ item.value }}
      </f-chip>
    </div>

    @if(targetCompanyData.customTargetRating) {
    <div class="body-50 text-muted">
      <p data-automation-id="custom-rating-info">
        {{
          'customRatingLastUpdatedByOn'
            | caLocalize
              : {
                  user:
                    (targetCompanyData.customTargetRating.lastModifiedUser | caAccountUserFullName) ||
                    ('inActiveUser' | caLocalize),
                  date: (targetCompanyData.customTargetRating.lastModifiedDate | caDate)
                }
        }}
      </p>
    </div>
    } @if(ratingValue) {
    <div class="body-50 text-muted">
      <p data-automation-id="system-rating">
        {{ 'systemSuggestedInstitutionRating' | caLocalize }} {{ localizedPriorityRatingValue }}
      </p>
    </div>
    }

    <ng-template fDrawerFooterTemplate>
      <div class="footer-with-buttons">
        <button class="btn btn-primary" [disabled]="!selectedInstitutionRating" (click)="onSave()">
          {{ 'saveButton' | caLocalize }}
        </button>
        <button class="btn btn-secondary" (click)="onCancel()">
          {{ 'cancelButton' | caLocalize }}
        </button>
      </div>
    </ng-template>
  </div>
</ng-container>
